import { Panel } from './Panel';
import { formatNumber } from '@/lib/utils';
import { ITEMS } from '@/data/items';
import type { Character } from '@/types/database';

interface CoffersPanelProps {
  character: Character;
}

interface CurrencyRowProps {
  label: string;
  value: number;
  icon: string;
  iconAlt: string;
  primary?: boolean;
  premium?: boolean;
}

function CurrencyRow({
  label,
  value,
  icon,
  iconAlt,
  primary,
  premium,
}: CurrencyRowProps): JSX.Element {
  return (
    <div className="flex items-center justify-between gap-4 py-3">
      <div className="flex items-center gap-4">
        <div className="h-12 w-12 sm:h-[4.5rem] sm:w-[4.5rem] shrink-0 rounded-lg border-2 border-wood-mid/40 overflow-hidden shadow-md">
          <img
            src={icon}
            alt={iconAlt}
            className="h-full w-full object-contain"
            loading="lazy"
            width={72}
            height={72}
          />
        </div>
        <span className="text-sm uppercase tracking-wider text-ink-mid">{label}</span>
      </div>
      <span
        className={`font-mono leading-none ${
          primary
            ? 'text-3xl font-display text-ink'
            : premium
              ? 'text-xl font-display text-candle-dark'
              : 'text-xl font-display text-blood'
        }`}
      >
        {formatNumber(value)}
      </span>
    </div>
  );
}

export function CoffersPanel({ character }: CoffersPanelProps): JSX.Element {
  return (
    <Panel title="Coffers">
      <div className="divide-y divide-wood-mid/20">
        <CurrencyRow
          label="Doubloons"
          value={character.doubloons}
          icon={ITEMS.doubloon.icon}
          iconAlt="Doubloon"
          primary
        />
        <CurrencyRow
          label="Marks"
          value={character.marks}
          icon={ITEMS.pirate_mark.icon}
          iconAlt="Pirate Mark"
          premium
        />
        {character.legendary_shards > 0 && (
          <CurrencyRow
            label="Legendary Shards"
            value={character.legendary_shards}
            icon={ITEMS.scroll.icon}
            iconAlt="Legendary Shard"
          />
        )}
      </div>
    </Panel>
  );
}
